// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Layout } from '../../components/index';
import { Content, Footer, Grid, Hero, StyledButton } from './styles';
import Image1 from 'assets/images/productDesign/image-1.png';
import Image2 from 'assets/images/productDesign/image-2.png';
import Image3 from 'assets/images/productDesign/image-3.png';
import Image4 from 'assets/images/productDesign/image-4.png';
import Image5 from 'assets/images/productDesign/image-5.png';
import Image6 from 'assets/images/productDesign/image-6.png';
import Image7 from 'assets/images/productDesign/image-7.png';

export const ProductDesign = () => {
  const navigate = useNavigate();
  const routePath = useLocation();

  const onTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    onTop();
  }, [routePath]);

  return (
    <Layout noPadding>
      <Content>
        <Hero>
          <img src={Image1} alt='' />
          <img src={Image2} alt='' />
          <img src={Image3} alt='' />
        </Hero>
        <Grid>
          <img src={Image5} alt='' />
          <img src={Image4} alt='' />
        </Grid>

        <Grid>
          <img src={Image7} alt='' />
          <img src={Image6} alt='' />
          <Footer>
            <StyledButton onClick={() => navigate('/')}>Go Back</StyledButton>
          </Footer>
        </Grid>
      </Content>
    </Layout>
  );
};
